// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"be415bbc","95":"5b2a1cd4","111":"e5587289","144":"bf1f63e7","156":"504f4a98","310":"203e476a","364":"cf525ddb","730":"91a35220","941":"e4a00ba8","956":"d2264bb3"}[chunkId] + ".chunk.js";
};